/**
 * Shown when a review/audit is completed but no feedback was detected.
 * Used by Team Dashboard and Web Dashboard ReviewCompleted views.
 */
export default function ReviewNoFeedback() {
  return (
    <div className="flex flex-col gap-24 w-full flex-1 items-center justify-center min-h-[200px]">
      <div className="text-center text-gray-500 flex flex-col gap-8">
        <span>
          No feedback detected for this review.
        </span>
        <span>
          Your design has been reviewed but we couldn&apos;t find any feedback this time.
        </span>
      </div>
    </div>
  );
}
